<div class="page">
  <div class="card">
    <div *ngIf="loading" class="row row--first">Loading recipient status…</div>
    <div *ngIf="error" class="row row--first">{{ error }}</div>

    <ng-container *ngIf="!loading && !error">
      <div
        class="row"
        *ngFor="let r of recipients; let i = index; trackBy: trackByEmail"
        [class.row--first]="i === 0"
        [class.row--editing]="editingRecipientId === r.recipientId"
        [class.row--clickable]="canEdit(r)"
        matTooltipPosition="above"
        (click)="onRowClick(r)"
      >
        <div class="order-badge">
            <span class="avatar" [style.background]="getAvatarColor($safeNavigationMigration(r?.roleName))">{{ getInitials($safeNavigationMigration(r?.roleName)) }}</span>  
            <div>   
              <div class="name"
                  [matTooltip]="r.name"
                  [matTooltipDisabled]="getDisplayName(r.name) === (r.name || '').trim()"
                  matTooltipPosition="above"
                >{{ getDisplayName(r.name) }} <span>({{r?.roleName}})</span>
                <button
                  type="button"
                  class="edit-pencil"
                  *ngIf="canEdit(r)"
                  aria-label="Correct email or phone"
                >
                  <mat-icon class="edit-pencil__icon">edit</mat-icon>
                </button>
              </div>
              <span class="sent-time"  *ngIf="getSentTime(r) as sentTs">{{ sentTs.label }}: {{ formatDateTime(sentTs.value) }}</span>
            </div>
        </div>

        <div class="identity">
          <span class="channel-chip  channel-capsule" *ngIf="r.email">
            <span>EMAIL</span>
            {{ r.email }}
          </span>

          <div class="channel-group" *ngIf="getPrimaryChannelLabel(r) || getSecondaryChannels(r).length">
            <span
              class="channel-chip channel-capsule"
              *ngIf="getPrimaryChannelLabel(r) as primary"
            >
              {{ primary }}
              <span *ngIf="r.phoneNumber">
                {{ formatPhone(r.phoneNumber) }}
              </span>
            </span>

            <!-- Secondary channel chips: extra notifications layered on top of email -->
            <span
              class="channel-chip channel-capsule"
              *ngFor="let n of getSecondaryChannels(r)"
            >
              {{ n.secondaryDeliveryMethod }}
              <span *ngIf="n.phoneNumber">
                {{ formatPhone(n.phoneNumber) }}
              </span>
            </span>
          </div>
        </div>

        <span class="badge" [ngClass]="'badge--' + getRecipientDisplayStatus(r).tone">
          <span class="badge-dot" [ngClass]="'dot--' + getRecipientDisplayStatus(r).tone"></span>
          {{ getRecipientDisplayStatus(r).label }}
          <span class="badge-resolved-time" *ngIf="getResolvedTime(r) as resolvedTs">
            {{ resolvedTs.label }}: {{ formatDateTime(resolvedTs.value) }}
          </span>
        </span>
      </div>
    </ng-container>
  </div>
</div>